import { useElementBounding } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { computed, reactive, ref, shallowRef } from 'vue'
import { useRoute } from 'vue-router'

import type MapGoogle from '@/components/Map/MapGoogle.vue'
import { useAppStore } from '@/store/modules/app'
import { useThemeStore } from '@/store/modules/theme'
import type { MapGoogleProps } from '@/types/map'

const elMapGoogle = shallowRef<InstanceType<typeof MapGoogle>>()

const mapOptionsDefaults = Object.freeze<MapGoogleProps>({
  cameraControl: false,
  clickableIcons: false,
  disableDoubleClickZoom: true,
  fullscreenControl: false,
  gestureHandling: 'greedy',
  mapTypeControl: false,
  rotateControl: false,
  scaleControl: true,
  scrollwheel: true,
  streetViewControl: false,
  zoomControl: true,
  zoomControlPosition: 'TOP_RIGHT',
})

const isCentered = ref<boolean>(false)

export const useSearchPage = () => {
  const { configTheme } = storeToRefs(useAppStore())

  const { elPageSearchList } = storeToRefs(useThemeStore())

  const route = useRoute()

  const elPageSearchListHeader = shallowRef<HTMLDivElement | null>(null)

  const elPageSearchListHeaderBounding = reactive(
    useElementBounding(elPageSearchListHeader),
  )
  const elPageSearchListHeaderBoundingHeight = computed(
    () => `${elPageSearchListHeaderBounding.height}px`,
  )

  const mapOptions = computed<MapGoogleProps>(() => {
    const _mapOptions = {
      ...mapOptionsDefaults,
      ...configTheme.value?.page.search.map.options,
    }

    delete _mapOptions.zoom

    return _mapOptions
  })

  const zoom = ref<number>(Number(route.query?.zoom?.toString()))

  return {
    elMapGoogle,
    elPageSearchList,
    elPageSearchListHeader,
    elPageSearchListHeaderBounding,
    elPageSearchListHeaderBoundingHeight,
    isCentered,
    mapOptions,
    zoom,
  }
}
